<!-- Transparent overlay for grid popups -->
<div class="overlayTransparent" *ngIf="this.ShowETAAlternatives == true || this.ShowSearchResultsAlternatives == true || this.ShowFallbackSelection == true || this.ShowBrandCollateral == true || this.ShowBrandCollateralNewProduct == true;" (click)="CloseGridPopupsOverlay();"></div>

<!-- ✅ Send PO Popup (3-Step Wizard) -->
<div class="ModernPopupOverlay" *ngIf="AskAddNewRFQasPOQuestion" (click)="resetPOWizard()">
  <div class="ModernPopup large wizard-popup" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">shopping_cart</i>
        <span>{{ 'AskAddNewRFQasPOQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="resetPOWizard()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- ✅ Wizard Stepper -->
    <div class="WizardStepper">
      <div class="WizardStep" [class.active]="currentPOStep === 1" [class.completed]="currentPOStep > 1" (click)="goToPOStep(1)">
        <div class="WizardStepNumber">
          <span *ngIf="currentPOStep <= 1">1</span>
          <i class="material-icons" *ngIf="currentPOStep > 1">check</i>
        </div>
        <span class="WizardStepLabel">{{ 'Shipping' | translate }}</span>
      </div>
      <div class="WizardStepLine" [class.completed]="currentPOStep > 1"></div>
      <div class="WizardStep" [class.active]="currentPOStep === 2" [class.completed]="currentPOStep > 2" (click)="goToPOStep(2)">
        <div class="WizardStepNumber">
          <span *ngIf="currentPOStep <= 2">2</span>
          <i class="material-icons" *ngIf="currentPOStep > 2">check</i>
        </div>
        <span class="WizardStepLabel">{{ 'OrderDetails' | translate }}</span>
      </div>
      <div class="WizardStepLine" [class.completed]="currentPOStep > 2"></div>
      <div class="WizardStep" [class.active]="currentPOStep === 3" [class.completed]="false">
        <div class="WizardStepNumber">3</div>
        <span class="WizardStepLabel">{{ 'ReviewConfirm' | translate }}</span>
      </div>
    </div>

    <div class="ModernPopupBody" (click)="closeAllPopupDropdowns()">

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 1: Shipping & Delivery -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentPOStep === 1">
        <div class="WizardSectionHeader">
          <i class="material-icons">local_shipping</i>
          <span>{{ 'ShippingDelivery' | translate }}</span>
        </div>

        <!-- Delivery Preference -->
        <div class="ModernFormGroup" style="position: relative; z-index: 106;">
          <label class="ModernFormLabel">{{ 'SelectDeliveryPrefference' | translate }}</label>
          <div class="SendEmailSearchContainer" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange !== true" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showDeliveryPreferenceDropdown" (click)="showDeliveryPreferenceDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showDeliveryPreferenceDropdown = !showDeliveryPreferenceDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">local_shipping</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.DeliveryPreference?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showDeliveryPreferenceDropdown">
              <div class="SendEmailSearchResult" *ngFor="let d of this.parent.CartMasterData?.DeliveryPreferences" (click)="selectDeliveryPreference(d)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.Cart?.DeliveryPreference?.ID === d.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.Cart?.DeliveryPreference?.ID === d.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ d.Name }}</span>
                </div>
                <div class="WizardFieldDescription" *ngIf="d.Description">{{ d.Description }}</div>
              </div>
            </div>
          </div>
          <div class="SendEmailSearchBar disabled" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
            <i class="material-icons send-email-icon" style="color: #999;">local_shipping</i>
            <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.DeliveryPreference?.Name || 'Select...'" readonly disabled />
            <i class="material-icons dropdown-icon" style="color: #999;">lock</i>
          </div>
          <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.DeliveryPreference?.Description">{{ this.parent.Cart.DeliveryPreference.Description }}</div>
          <div class="ModernFormBlockedInfo" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
            <i class="material-icons">info_outline</i>
            <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
          </div>
        </div>

        <!-- Shipping Address -->
        <div class="ModernFormGroup" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0" style="position: relative; z-index: 105;">
          <label class="ModernFormLabel">{{ 'ShippingAddress' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showShippingAddressDropdown = !showShippingAddressDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">location_on</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.OfferRequest?.ShippingAddress ? (this.parent.OfferRequest.ShippingAddress.Country?.Name + ' - ' + this.parent.OfferRequest.ShippingAddress.City + ' - ' + this.parent.OfferRequest.ShippingAddress.AddressLine) : 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showShippingAddressDropdown">
              <div class="SendEmailSearchResult" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ addr.Country?.Name }} - {{ addr.City }} - {{ addr.AddressLine }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Service Type -->
        <div class="ModernFormGroup" *ngIf="ShippingServiceTypes?.length > 0" style="position: relative; z-index: 104;">
          <label class="ModernFormLabel">{{ 'SelectShippingServiceType' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">speed</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.ShippingServiceType?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showShippingServiceTypeDropdown">
              <div class="SendEmailSearchResult" *ngFor="let stype of ShippingServiceTypes" (click)="selectShippingServiceType(stype)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.Cart?.ShippingServiceType?.ID === stype.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.Cart?.ShippingServiceType?.ID === stype.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ stype.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Company -->
        <div class="ModernFormGroup" *ngIf="ShippingCompanies?.length > 0" [style.position]="'relative'" [style.z-index]="showShippingCompanyDropdown ? 107 : 103">
          <label class="ModernFormLabel">{{ 'SelectShippingCompany' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showShippingCompanyDropdown = !showShippingCompanyDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">business</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.ShippingCompany?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showShippingCompanyDropdown" style="top: auto; bottom: calc(100% + 4px); box-shadow: 0 -4px 12px rgba(74, 123, 184, 0.15);">
              <div class="SendEmailSearchResult" *ngFor="let company of ShippingCompanies" (click)="selectShippingCompany(company)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.Cart?.ShippingCompany?.ID === company.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.Cart?.ShippingCompany?.ID === company.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ company.Name }}</span>
                </div>
              </div>
            </div>
          </div>
          <mat-spinner class="smallSpinner" [diameter]="18" *ngIf="loadingShippingOptions"></mat-spinner>
        </div>

        <!-- Shipping Responsibility -->
        <div class="ModernFormGroup" *ngIf="ShippingResponsabilities?.length > 0" [style.position]="'relative'" [style.z-index]="showShippingResponsabilityDropdown ? 107 : 102">
          <label class="ModernFormLabel">{{ 'SelectShippingResponsability' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">assignment_ind</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.ShippingResponsability?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showShippingResponsabilityDropdown" style="top: auto; bottom: calc(100% + 4px); box-shadow: 0 -4px 12px rgba(74, 123, 184, 0.15);">
              <div class="SendEmailSearchResult" *ngFor="let resp of ShippingResponsabilities" (click)="selectShippingResponsability(resp)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.Cart?.ShippingResponsability?.ID === resp.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.Cart?.ShippingResponsability?.ID === resp.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ resp.Name }}</span>
                </div>
                <div class="WizardFieldDescription" *ngIf="resp.Description">{{ resp.Description }}</div>
              </div>
            </div>
          </div>
          <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.ShippingResponsability?.Description">{{ this.parent.Cart.ShippingResponsability.Description }}</div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 2: Order Details & Contacts -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentPOStep === 2">
        <div class="WizardSectionHeader">
          <i class="material-icons">description</i>
          <span>{{ 'OrderDetailsContacts' | translate }}</span>
        </div>

        <!-- Order Consolidation Type -->
        <div class="ModernFormGroup" *ngIf="this.OfferRequestMasterData?.OrderConsolidationTypes?.length > 0" style="position: relative; z-index: 104;">
          <label class="ModernFormLabel">{{ 'OrderConsolidationType' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showConsolidationTypeDropdown" (click)="showConsolidationTypeDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showConsolidationTypeDropdown = !showConsolidationTypeDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">merge_type</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.OfferRequest?.ConsolidationType?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showConsolidationTypeDropdown">
              <div class="SendEmailSearchResult" *ngFor="let type of this.OfferRequestMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.OfferRequest?.ConsolidationType?.ID === type.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.OfferRequest?.ConsolidationType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ type.Name }}</span>
                </div>
                <div class="WizardFieldDescription" *ngIf="type.Description">{{ type.Description }}</div>
              </div>
            </div>
          </div>
          <div class="WizardFieldDescription" *ngIf="this.parent.OfferRequest?.ConsolidationType?.Description">{{ this.parent.OfferRequest.ConsolidationType.Description }}</div>
        </div>

        <!-- Partner Agents (Multiple) -->
        <div class="ModernFormGroup" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0">
          <label class="ModernFormLabel">{{ 'SelectAgents' | translate }}</label>
          <div class="ToggleCheckboxGroup">
            <div class="AgentPhaseBlock" *ngFor="let agent of this.parent.B2BPartner.PartnerAgents">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [checked]="isAgentSelected(agent)" (change)="toggleAgentSelection(agent)">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{agent.Name}} - {{agent.Email}}</span>
                <button class="AgentSelectPhasesBtn" *ngIf="isAgentSelected(agent)"
                        [class.has-phases]="agent.OrderPhases?.length > 0"
                        (click)="openB2BAgentPhasesPopup(agent); $event.stopPropagation();">
                  <i class="material-icons">tune</i>
                  <span>{{ 'SelectNotificationPhases' | translate }}</span>
                  <span class="AgentPhasesCount" *ngIf="agent.OrderPhases?.length > 0">{{agent.OrderPhases.length}}</span>
                  <i class="material-icons AgentPhaseExpandArrow">expand_more</i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Partner Reference Number -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">
            <i class="material-icons" style="color: #f60; font-size: 16px; vertical-align: middle; margin-right: 4px;">info_outline</i>
            {{'UIPartnerReferenceNumberDescription' | translate}} ({{'Recommended' | translate}})
          </label>
          <div class="ModernFormInputWrapper wizard-highlight-urgent">
            <input type="text" class="ModernFormInput" [class.ModernFormInputHighlight]="!parent.OfferRequest.DebatorPO || parent.OfferRequest.DebatorPO.length === 0" [(ngModel)]="parent.OfferRequest.DebatorPO" placeholder="{{ 'UIPartnerReferenceNumber' | translate }}">
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 3: Review & Confirm -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentPOStep === 3">
        <!-- Disclaimers -->
        <p class="ModernPopupDescription">{{ 'AskAddNewRFQasPOQuestionDescription' | translate }}</p>
        <p class="ModernPopupDisclaimer">{{ 'PurchaseOrderDisclaimer' | translate }}</p>
        <p class="ModernPopupDisclaimer ModernPopupDisclaimerStrong" [innerHTML]="getPOObligationDisclaimer('PurchaseOrderObligationDisclaimer' | translate)"></p>

        <div class="WizardSectionHeader">
          <i class="material-icons">fact_check</i>
          <span>{{ 'ReviewConfirm' | translate }}</span>
        </div>

        <!-- Summary Card (editable dropdowns) -->
        <div class="WizardSummaryCard" (click)="closeAllPopupDropdowns()">

          <!-- Delivery Preference -->
          <div class="WizardSummaryRowEditable" style="z-index: 108;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showDeliveryPreferenceDropdown = !showDeliveryPreferenceDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">local_shipping</i></div>
              <div class="WizardSummaryLabel">{{ 'DeliveryPreference' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.Cart?.DeliveryPreference?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showDeliveryPreferenceDropdown" (click)="showDeliveryPreferenceDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showDeliveryPreferenceDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let d of this.parent.CartMasterData?.DeliveryPreferences" (click)="selectDeliveryPreference(d)">
                <span>{{ d.Name }}<span *ngIf="d.Description" style="color: #86868b; font-weight: 400;"> ({{ d.Description }})</span></span>
                <i class="material-icons" *ngIf="this.parent.Cart?.DeliveryPreference?.ID === d.ID" style="color: #007aff;">check</i>
              </div>
            </div>
            <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.DeliveryPreference?.Description">{{ this.parent.Cart.DeliveryPreference.Description }}</div>
          </div>

          <!-- Shipping Address -->
          <div class="WizardSummaryRowEditable" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0" style="z-index: 107;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showShippingAddressDropdown = !showShippingAddressDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">location_on</i></div>
              <div class="WizardSummaryLabel">{{ 'ShippingAddress' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.OfferRequest?.ShippingAddress ? (this.parent.OfferRequest.ShippingAddress.Country?.Name + ' - ' + this.parent.OfferRequest.ShippingAddress.City) : '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showShippingAddressDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr)">
                <span>{{ addr.Country?.Name }} - {{ addr.City }} - {{ addr.AddressLine }}</span>
                <i class="material-icons" *ngIf="this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Shipping Service Type -->
          <div class="WizardSummaryRowEditable" *ngIf="ShippingServiceTypes?.length > 0" style="z-index: 106;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">speed</i></div>
              <div class="WizardSummaryLabel">{{ 'SelectShippingServiceType' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.Cart?.ShippingServiceType?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showShippingServiceTypeDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let stype of ShippingServiceTypes" (click)="selectShippingServiceType(stype)">
                <span>{{ stype.Name }}</span>
                <i class="material-icons" *ngIf="this.parent.Cart?.ShippingServiceType?.ID === stype.ID" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Shipping Company -->
          <div class="WizardSummaryRowEditable" *ngIf="ShippingCompanies?.length > 0" style="z-index: 105;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showShippingCompanyDropdown = !showShippingCompanyDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">business</i></div>
              <div class="WizardSummaryLabel">{{ 'SelectShippingCompany' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.Cart?.ShippingCompany?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showShippingCompanyDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let company of ShippingCompanies" (click)="selectShippingCompany(company)">
                <span>{{ company.Name }}</span>
                <i class="material-icons" *ngIf="this.parent.Cart?.ShippingCompany?.ID === company.ID" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Shipping Responsibility -->
          <div class="WizardSummaryRowEditable" *ngIf="ShippingResponsabilities?.length > 0" style="z-index: 104;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">assignment_ind</i></div>
              <div class="WizardSummaryLabel">{{ 'SelectShippingResponsability' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.Cart?.ShippingResponsability?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showShippingResponsabilityDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let resp of ShippingResponsabilities" (click)="selectShippingResponsability(resp)">
                <span>{{ resp.Name }}<span *ngIf="resp.Description" style="color: #86868b; font-weight: 400;"> ({{ resp.Description }})</span></span>
                <i class="material-icons" *ngIf="this.parent.Cart?.ShippingResponsability?.ID === resp.ID" style="color: #007aff;">check</i>
              </div>
            </div>
            <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.ShippingResponsability?.Description">{{ this.parent.Cart.ShippingResponsability.Description }}</div>
          </div>

          <!-- Consolidation Type -->
          <div class="WizardSummaryRowEditable" *ngIf="this.OfferRequestMasterData?.OrderConsolidationTypes?.length > 0" style="z-index: 103;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showConsolidationTypeDropdown = !showConsolidationTypeDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">merge_type</i></div>
              <div class="WizardSummaryLabel">{{ 'OrderConsolidationType' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.OfferRequest?.ConsolidationType?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showConsolidationTypeDropdown" (click)="showConsolidationTypeDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showConsolidationTypeDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let type of this.OfferRequestMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type)">
                <span>{{ type.Name }}<span *ngIf="type.Description" style="color: #86868b; font-weight: 400;"> ({{ type.Description }})</span></span>
                <i class="material-icons" *ngIf="this.parent.OfferRequest?.ConsolidationType?.ID === type.ID" style="color: #007aff;">check</i>
              </div>
            </div>
            <div class="WizardFieldDescription" *ngIf="this.parent.OfferRequest?.ConsolidationType?.Description">{{ this.parent.OfferRequest.ConsolidationType.Description }}</div>
          </div>

          <!-- Agents (multi-select) -->
          <div class="WizardSummaryRowEditable" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0" style="z-index: 102;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showAgentsDropdown = !showAgentsDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">people</i></div>
              <div class="WizardSummaryLabel">{{ 'Agents' | translate }}</div>
              <div class="WizardSummaryValue">{{ getSelectedAgentsSummary() }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showAgentsDropdown" (click)="showAgentsDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showAgentsDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let agent of this.parent.B2BPartner.PartnerAgents" (click)="toggleAgentSelection(agent)">
                <span>{{ agent.Name }} - {{ agent.Email }}</span>
                <i class="material-icons" *ngIf="isAgentSelected(agent)" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Your Reference (static) -->
          <div class="WizardSummaryRow" *ngIf="parent.OfferRequest.DebatorPO">
            <div class="WizardSummaryIcon"><i class="material-icons">tag</i></div>
            <div class="WizardSummaryLabel">{{ 'YourReference' | translate }}</div>
            <div class="WizardSummaryValue">{{ parent.OfferRequest.DebatorPO }}</div>
          </div>
        </div>

        <!-- Products Table -->
        <div class="WizardProductsTable">
          <div class="WizardProductsScrollContainer">
            <table class="WizardProductsTableInner">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ 'Brand' | translate }}</th>
                  <th>{{ 'PartNumber' | translate }}</th>
                  <th>{{ 'ProductName' | translate }}</th>
                  <th>{{ 'Quantity' | translate }}</th>
                  <th>{{ 'SellPrice' | translate }}</th>
                  <th>{{ 'Total' | translate }}</th>
                  <th>{{ 'ETA' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getValidCartItems(); let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.Product?.Brand?.Name }}</td>
                  <td>{{ item.Product?.PartNumber }}</td>
                  <td>{{ item.Product?.Name }}</td>
                  <td>{{ item.Quantity }}</td>
                  <td>{{ item.SelectedOffer?.SellPrice?.UIUnitPrice > 0 ? (item.SelectedOffer.SellPrice.UIUnitPrice | number:'1.2-2') : '-' }}</td>
                  <td>{{ item.Price?.UIQtyPrice > 0 ? (item.Price.UIQtyPrice | number:'1.2-2') : '-' }}</td>
                  <td>{{ item.SelectedOffer?.LeadTime?.UIOutput || '------' }}</td>
                  <td>
                    <button class="WizardProductRemoveBtn" (click)="askRemoveCartItemFromWizard(item)" title="Remove">
                      <i class="material-icons">close</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Wizard Delete Confirmation Overlay -->
        <div class="WizardDeleteOverlay" *ngIf="wizardDeleteConfirmUIID" (click)="cancelWizardDelete()">
          <div class="WizardDeleteConfirm" (click)="$event.stopPropagation()">
            <div class="WizardDeleteIcon">
              <i class="material-icons">delete_outline</i>
            </div>
            <p class="WizardDeleteTitle">{{ 'Configuration.DeleteQuestion' | translate }}</p>
            <p class="WizardDeleteProduct">{{ wizardDeleteConfirmProductName }}</p>
            <div class="WizardDeleteActions">
              <button class="ModernButton outline" (click)="cancelWizardDelete()">{{ 'Configuration.DeleteNoButton' | translate }}</button>
              <button class="ModernButton danger" (click)="confirmWizardDelete()">
                <i class="material-icons">delete</i>
                <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Total highlight row -->
        <div class="WizardSummaryCard">
          <div class="WizardSummaryRow highlight">
            <div class="WizardSummaryIcon"><i class="material-icons">payments</i></div>
            <div class="WizardSummaryLabel">{{ 'Total' | translate }}</div>
            <div class="WizardSummaryValue">{{ getCartTotal() }}</div>
          </div>
        </div>

      </div>

    </div>

    <!-- ✅ Wizard Footer with Navigation -->
    <div class="ModernPopupFooter WizardFooter">
      <button class="ModernButton outline" (click)="resetPOWizard()">
        {{ 'Cancel' | translate }}
      </button>
      <div class="WizardNavButtons">
        <button class="ModernButton outline" *ngIf="currentPOStep > 1" (click)="prevPOStep()">
          <i class="material-icons">arrow_back</i>
          <span>{{ 'Back' | translate }}</span>
        </button>
        <button class="ModernButton primary" *ngIf="currentPOStep < 3" (click)="nextPOStep()">
          <span>{{ 'Next' | translate }}</span>
          <i class="material-icons">arrow_forward</i>
        </button>
        <button class="ModernButton success" *ngIf="currentPOStep === 3 && this.parent.Cart?.Status?.ID != 1 && this.parent.loading !== true" (click)="this.AddNewOffer(false, this.parent.Cart);">
          <i class="material-icons">send</i>
          <span>{{ 'SendRFQ' | translate }}</span>
        </button>
        <button class="ModernButton primary" *ngIf="currentPOStep === 3 && this.parent.Cart?.Status?.ID == 1 && this.parent.loading !== true" (click)="this.AddNewOffer(true, this.parent.Cart);">
          <i class="material-icons">arrow_forward</i>
          <span>{{ 'SendPO' | translate }}</span>
        </button>
        <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="currentPOStep === 3 && this.parent.loading === true;"></mat-spinner>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Send RFQ Popup (3-Step Wizard) -->
<div class="ModernPopupOverlay" *ngIf="AskAddNewRFQQuestion" (click)="resetRFQWizard()">
  <div class="ModernPopup large wizard-popup" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">local_offer</i>
        <span>{{ 'AskAddNewRFQQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="resetRFQWizard()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- ✅ Wizard Stepper -->
    <div class="WizardStepper">
      <div class="WizardStep" [class.active]="currentRFQStep === 1" [class.completed]="currentRFQStep > 1" (click)="goToRFQStep(1)">
        <div class="WizardStepNumber">
          <span *ngIf="currentRFQStep <= 1">1</span>
          <i class="material-icons" *ngIf="currentRFQStep > 1">check</i>
        </div>
        <span class="WizardStepLabel">{{ 'Shipping' | translate }}</span>
      </div>
      <div class="WizardStepLine" [class.completed]="currentRFQStep > 1"></div>
      <div class="WizardStep" [class.active]="currentRFQStep === 2" [class.completed]="currentRFQStep > 2" (click)="goToRFQStep(2)">
        <div class="WizardStepNumber">
          <span *ngIf="currentRFQStep <= 2">2</span>
          <i class="material-icons" *ngIf="currentRFQStep > 2">check</i>
        </div>
        <span class="WizardStepLabel">{{ 'OrderDetails' | translate }}</span>
      </div>
      <div class="WizardStepLine" [class.completed]="currentRFQStep > 2"></div>
      <div class="WizardStep" [class.active]="currentRFQStep === 3" [class.completed]="false">
        <div class="WizardStepNumber">3</div>
        <span class="WizardStepLabel">{{ 'ReviewConfirm' | translate }}</span>
      </div>
    </div>

    <div class="ModernPopupBody" (click)="closeAllPopupDropdowns()">

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 1: Shipping & Delivery -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentRFQStep === 1">
        <div class="WizardSectionHeader">
          <i class="material-icons">local_shipping</i>
          <span>{{ 'ShippingDelivery' | translate }}</span>
        </div>

        <!-- Delivery Preference -->
        <div class="ModernFormGroup" style="position: relative; z-index: 104;">
          <label class="ModernFormLabel">{{ 'SelectDeliveryPrefference' | translate }}</label>
          <div class="SendEmailSearchContainer" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange !== true" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showDeliveryPreferenceDropdown" (click)="showDeliveryPreferenceDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showDeliveryPreferenceDropdown = !showDeliveryPreferenceDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">local_shipping</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.DeliveryPreference?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showDeliveryPreferenceDropdown">
              <div class="SendEmailSearchResult" *ngFor="let d of this.parent.CartMasterData?.DeliveryPreferences" (click)="selectDeliveryPreference(d)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.Cart?.DeliveryPreference?.ID === d.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.Cart?.DeliveryPreference?.ID === d.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ d.Name }}</span>
                </div>
                <div class="WizardFieldDescription" *ngIf="d.Description">{{ d.Description }}</div>
              </div>
            </div>
          </div>
          <div class="SendEmailSearchBar disabled" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
            <i class="material-icons send-email-icon" style="color: #999;">local_shipping</i>
            <input type="text" class="SendEmailSearchInput" [value]="this.parent.Cart?.DeliveryPreference?.Name || 'Select...'" readonly disabled />
            <i class="material-icons dropdown-icon" style="color: #999;">lock</i>
          </div>
          <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.DeliveryPreference?.Description">{{ this.parent.Cart.DeliveryPreference.Description }}</div>
          <div class="ModernFormBlockedInfo" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
            <i class="material-icons">info_outline</i>
            <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
          </div>
        </div>

        <!-- Shipping Address -->
        <div class="ModernFormGroup" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0" style="position: relative; z-index: 103;">
          <label class="ModernFormLabel">{{ 'ShippingAddress' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showShippingAddressDropdown = !showShippingAddressDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">location_on</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.OfferRequest?.ShippingAddress ? (this.parent.OfferRequest.ShippingAddress.Country?.Name + ' - ' + this.parent.OfferRequest.ShippingAddress.City + ' - ' + this.parent.OfferRequest.ShippingAddress.AddressLine) : 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showShippingAddressDropdown">
              <div class="SendEmailSearchResult" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ addr.Country?.Name }} - {{ addr.City }} - {{ addr.AddressLine }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 2: Order Details & Contacts -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentRFQStep === 2">
        <div class="WizardSectionHeader">
          <i class="material-icons">description</i>
          <span>{{ 'OrderDetailsContacts' | translate }}</span>
        </div>

        <!-- Order Consolidation Type -->
        <div class="ModernFormGroup" *ngIf="this.OfferRequestMasterData?.OrderConsolidationTypes?.length > 0" style="position: relative; z-index: 104;">
          <label class="ModernFormLabel">{{ 'OrderConsolidationType' | translate }}</label>
          <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
            <div class="SendEmailOverlayTransparent" *ngIf="showConsolidationTypeDropdown" (click)="showConsolidationTypeDropdown = false"></div>
            <div class="SendEmailSearchBar" (click)="showConsolidationTypeDropdown = !showConsolidationTypeDropdown">
              <i class="material-icons send-email-icon" style="color: #4a7bb8;">merge_type</i>
              <input type="text" class="SendEmailSearchInput" [value]="this.parent.OfferRequest?.ConsolidationType?.Name || 'Select...'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="SendEmailSearchResults" *ngIf="showConsolidationTypeDropdown">
              <div class="SendEmailSearchResult" *ngFor="let type of this.OfferRequestMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type)">
                <div class="SendEmailResultMain">
                  <i class="material-icons" [style.color]="this.parent.OfferRequest?.ConsolidationType?.ID === type.ID ? '#4caf50' : '#f44336'">
                    {{ this.parent.OfferRequest?.ConsolidationType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="SendEmailResultLabel">{{ type.Name }}</span>
                </div>
                <div class="WizardFieldDescription" *ngIf="type.Description">{{ type.Description }}</div>
              </div>
            </div>
          </div>
          <div class="WizardFieldDescription" *ngIf="this.parent.OfferRequest?.ConsolidationType?.Description">{{ this.parent.OfferRequest.ConsolidationType.Description }}</div>
        </div>

        <!-- Partner Agents (Multiple) -->
        <div class="ModernFormGroup" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0">
          <label class="ModernFormLabel">{{ 'SelectAgents' | translate }}</label>
          <div class="ToggleCheckboxGroup">
            <div class="AgentPhaseBlock" *ngFor="let agent of this.parent.B2BPartner.PartnerAgents">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [checked]="isAgentSelected(agent)" (change)="toggleAgentSelection(agent)">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{agent.Name}} - {{agent.Email}}</span>
                <button class="AgentSelectPhasesBtn" *ngIf="isAgentSelected(agent)"
                        [class.has-phases]="agent.OrderPhases?.length > 0"
                        (click)="openB2BAgentPhasesPopup(agent); $event.stopPropagation();">
                  <i class="material-icons">tune</i>
                  <span>{{ 'SelectNotificationPhases' | translate }}</span>
                  <span class="AgentPhasesCount" *ngIf="agent.OrderPhases?.length > 0">{{agent.OrderPhases.length}}</span>
                  <i class="material-icons AgentPhaseExpandArrow">expand_more</i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Partner Reference Number -->
        <div class="ModernFormGroup">
          <label class="ModernFormLabel">
            <i class="material-icons" style="color: #f60; font-size: 16px; vertical-align: middle; margin-right: 4px;">info_outline</i>
            {{'UIPartnerReferenceNumberDescription' | translate}} ({{'Recommended' | translate}})
          </label>
          <div class="ModernFormInputWrapper wizard-highlight-urgent">
            <input type="text" class="ModernFormInput" [class.ModernFormInputHighlight]="!parent.OfferRequest.DebatorPO || parent.OfferRequest.DebatorPO.length === 0" [(ngModel)]="parent.OfferRequest.DebatorPO" placeholder="{{ 'UIPartnerReferenceNumber' | translate }}">
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- STEP 3: Review & Confirm -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <div class="WizardStepContent" *ngIf="currentRFQStep === 3">
        <!-- Disclaimers -->
        <p class="ModernPopupDescription">{{ 'AskAddNewRFQQuestionDescription' | translate }}</p>
        <p class="ModernPopupDisclaimer">{{ 'QuotationDisclaimer' | translate }}</p>

        <div class="WizardSectionHeader">
          <i class="material-icons">fact_check</i>
          <span>{{ 'ReviewConfirm' | translate }}</span>
        </div>

        <!-- Summary Card (editable dropdowns) -->
        <div class="WizardSummaryCard" (click)="closeAllPopupDropdowns()">

          <!-- Delivery Preference -->
          <div class="WizardSummaryRowEditable" style="z-index: 108;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showDeliveryPreferenceDropdown = !showDeliveryPreferenceDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">local_shipping</i></div>
              <div class="WizardSummaryLabel">{{ 'DeliveryPreference' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.Cart?.DeliveryPreference?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showDeliveryPreferenceDropdown" (click)="showDeliveryPreferenceDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showDeliveryPreferenceDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let d of this.parent.CartMasterData?.DeliveryPreferences" (click)="selectDeliveryPreference(d)">
                <span>{{ d.Name }}<span *ngIf="d.Description" style="color: #86868b; font-weight: 400;"> ({{ d.Description }})</span></span>
                <i class="material-icons" *ngIf="this.parent.Cart?.DeliveryPreference?.ID === d.ID" style="color: #007aff;">check</i>
              </div>
            </div>
            <div class="WizardFieldDescription" *ngIf="this.parent.Cart?.DeliveryPreference?.Description">{{ this.parent.Cart.DeliveryPreference.Description }}</div>
          </div>

          <!-- Shipping Address -->
          <div class="WizardSummaryRowEditable" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0" style="z-index: 107;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showShippingAddressDropdown = !showShippingAddressDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">location_on</i></div>
              <div class="WizardSummaryLabel">{{ 'ShippingAddress' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.OfferRequest?.ShippingAddress ? (this.parent.OfferRequest.ShippingAddress.Country?.Name + ' - ' + this.parent.OfferRequest.ShippingAddress.City) : '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showShippingAddressDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr)">
                <span>{{ addr.Country?.Name }} - {{ addr.City }} - {{ addr.AddressLine }}</span>
                <i class="material-icons" *ngIf="this.parent.OfferRequest?.ShippingAddress?.ID === addr.ID" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Consolidation Type -->
          <div class="WizardSummaryRowEditable" *ngIf="this.OfferRequestMasterData?.OrderConsolidationTypes?.length > 0" style="z-index: 106;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showConsolidationTypeDropdown = !showConsolidationTypeDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">merge_type</i></div>
              <div class="WizardSummaryLabel">{{ 'OrderConsolidationType' | translate }}</div>
              <div class="WizardSummaryValue">{{ this.parent.OfferRequest?.ConsolidationType?.Name || '-' }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showConsolidationTypeDropdown" (click)="showConsolidationTypeDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showConsolidationTypeDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let type of this.OfferRequestMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type)">
                <span>{{ type.Name }}<span *ngIf="type.Description" style="color: #86868b; font-weight: 400;"> ({{ type.Description }})</span></span>
                <i class="material-icons" *ngIf="this.parent.OfferRequest?.ConsolidationType?.ID === type.ID" style="color: #007aff;">check</i>
              </div>
            </div>
            <div class="WizardFieldDescription" *ngIf="this.parent.OfferRequest?.ConsolidationType?.Description">{{ this.parent.OfferRequest.ConsolidationType.Description }}</div>
          </div>

          <!-- Agents (multi-select) -->
          <div class="WizardSummaryRowEditable" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0" style="z-index: 105;">
            <div class="WizardSummaryRow" (click)="$event.stopPropagation(); showAgentsDropdown = !showAgentsDropdown">
              <div class="WizardSummaryIcon"><i class="material-icons">people</i></div>
              <div class="WizardSummaryLabel">{{ 'Agents' | translate }}</div>
              <div class="WizardSummaryValue">{{ getSelectedAgentsSummary() }} <i class="material-icons dropdown-arrow">arrow_drop_down</i></div>
            </div>
            <div class="WizardSummaryDropdownOverlay" *ngIf="showAgentsDropdown" (click)="showAgentsDropdown = false"></div>
            <div class="WizardSummaryDropdown" *ngIf="showAgentsDropdown" (click)="$event.stopPropagation()">
              <div class="WizardSummaryDropdownItem" *ngFor="let agent of this.parent.B2BPartner.PartnerAgents" (click)="toggleAgentSelection(agent)">
                <span>{{ agent.Name }} - {{ agent.Email }}</span>
                <i class="material-icons" *ngIf="isAgentSelected(agent)" style="color: #007aff;">check</i>
              </div>
            </div>
          </div>

          <!-- Your Reference (static) -->
          <div class="WizardSummaryRow" *ngIf="parent.OfferRequest.DebatorPO">
            <div class="WizardSummaryIcon"><i class="material-icons">tag</i></div>
            <div class="WizardSummaryLabel">{{ 'YourReference' | translate }}</div>
            <div class="WizardSummaryValue">{{ parent.OfferRequest.DebatorPO }}</div>
          </div>
        </div>

        <!-- Products Table -->
        <div class="WizardProductsTable">
          <div class="WizardProductsScrollContainer">
            <table class="WizardProductsTableInner">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ 'Brand' | translate }}</th>
                  <th>{{ 'PartNumber' | translate }}</th>
                  <th>{{ 'ProductName' | translate }}</th>
                  <th>{{ 'Quantity' | translate }}</th>
                  <th>{{ 'SellPrice' | translate }}</th>
                  <th>{{ 'Total' | translate }}</th>
                  <th>{{ 'ETA' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getValidCartItems(); let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.Product?.Brand?.Name }}</td>
                  <td>{{ item.Product?.PartNumber }}</td>
                  <td>{{ item.Product?.Name }}</td>
                  <td>{{ item.Quantity }}</td>
                  <td>{{ item.SelectedOffer?.SellPrice?.UIUnitPrice > 0 ? (item.SelectedOffer.SellPrice.UIUnitPrice | number:'1.2-2') : '-' }}</td>
                  <td>{{ item.Price?.UIQtyPrice > 0 ? (item.Price.UIQtyPrice | number:'1.2-2') : '-' }}</td>
                  <td>{{ item.SelectedOffer?.LeadTime?.UIOutput || '------' }}</td>
                  <td>
                    <button class="WizardProductRemoveBtn" (click)="askRemoveCartItemFromWizard(item)" title="Remove">
                      <i class="material-icons">close</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Wizard Delete Confirmation Overlay -->
        <div class="WizardDeleteOverlay" *ngIf="wizardDeleteConfirmUIID" (click)="cancelWizardDelete()">
          <div class="WizardDeleteConfirm" (click)="$event.stopPropagation()">
            <div class="WizardDeleteIcon">
              <i class="material-icons">delete_outline</i>
            </div>
            <p class="WizardDeleteTitle">{{ 'Configuration.DeleteQuestion' | translate }}</p>
            <p class="WizardDeleteProduct">{{ wizardDeleteConfirmProductName }}</p>
            <div class="WizardDeleteActions">
              <button class="ModernButton outline" (click)="cancelWizardDelete()">{{ 'Configuration.DeleteNoButton' | translate }}</button>
              <button class="ModernButton danger" (click)="confirmWizardDelete()">
                <i class="material-icons">delete</i>
                <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Total highlight row -->
        <div class="WizardSummaryCard">
          <div class="WizardSummaryRow highlight">
            <div class="WizardSummaryIcon"><i class="material-icons">payments</i></div>
            <div class="WizardSummaryLabel">{{ 'Total' | translate }}</div>
            <div class="WizardSummaryValue">{{ getCartTotal() }}</div>
          </div>
        </div>

      </div>

    </div>

    <!-- ✅ Wizard Footer with Navigation -->
    <div class="ModernPopupFooter WizardFooter">
      <button class="ModernButton outline" (click)="resetRFQWizard()">
        {{ 'Cancel' | translate }}
      </button>
      <div class="WizardNavButtons">
        <button class="ModernButton outline" *ngIf="currentRFQStep > 1" (click)="prevRFQStep()">
          <i class="material-icons">arrow_back</i>
          <span>{{ 'Back' | translate }}</span>
        </button>
        <button class="ModernButton primary" *ngIf="currentRFQStep < 3" (click)="nextRFQStep()">
          <span>{{ 'Next' | translate }}</span>
          <i class="material-icons">arrow_forward</i>
        </button>
        <button class="ModernButton warning" *ngIf="currentRFQStep === 3 && this.parent.Cart?.Status?.ID != 1 && this.parent.loading !== true" (click)="this.AddNewOffer(false, this.parent.Cart);">
          <i class="material-icons">send</i>
          <span>{{ 'SendRFQ' | translate }}</span>
        </button>
        <button class="ModernButton primary" *ngIf="currentRFQStep === 3 && this.parent.Cart?.Status?.ID == 1 && this.parent.loading !== true" (click)="this.AddNewOffer(true, this.parent.Cart);">
          <i class="material-icons">arrow_forward</i>
          <span>{{ 'SendPO' | translate }}</span>
        </button>
        <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="currentRFQStep === 3 && this.parent.loading === true;"></mat-spinner>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Clear Grid Confirmation Popup (ModernPopup style) -->
<div class="ModernPopupOverlay" *ngIf="ClearGridQuestion" (click)="ClearGridQuestion = false;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #fd4f57;">warning</i>
        <span>{{ 'ClearGridQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ClearGridQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'ClearGridConfirmation' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.loading" (click)="ClearGridQuestion = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.loading" (click)="ClearGridQuestion = false; ClearGrid();">
        <i class="material-icons">close</i>
        <span>{{ 'ClearGrid' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Tab Switcher: Product-Pricing / Terms & Conditions -->
<div class="GridModeTabsWrapper">
  <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': activeSearchTab === 'pricing'}" (click)="activeSearchTab = 'pricing'">
    <i class="material-icons">shopping_cart</i>
    <span>{{ 'ProductPricing' | translate }}</span>
  </div>
  <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': activeSearchTab === 'terms'}" (click)="activeSearchTab = 'terms'">
    <i class="material-icons">gavel</i>
    <span>{{ 'TermsAndConditions' | translate }}</span>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════ -->
<!-- TAB: Terms & Conditions -->
<!-- ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="activeSearchTab === 'terms'">

<div class="WelcomeInfoRow">
  <i class="material-icons">info</i>
  <span>{{'AllPricesNetPrices' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">info</i>
  <span>{{'RFQBasicInfo' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">info</i>
  <span>{{'AllGreenPOPossibility' | translate}}</span>
</div>

<div class="ListPriceBrandsContainer" *ngIf="this.parent.B2BPartner?.FinancialData?.Status?.ID !== -3">
  <div *ngIf="this.loadingBrandIcons != true;">
    <div [ngClass]="{'ImportantBrand': b.Rank > 0}" class="ListPriceBrand" *ngFor="let b of this.Brands; let i = index;" matTooltip="({{b.Name}}) {{'AvailableUntil' | translate}}: {{b.AvailabilityDateUI}}" matTooltipClass='neutral-tool-tip'>
      <div class="BrandImage">
        <img [src]="this.parent.BackendServiceUrl + b.LogoPath">
      </div>
    </div>
  </div>
  <div *ngIf="this.loadingBrandIcons == true;" class="brandSpinnerContainer">
    <mat-spinner class="brandSpinner" [diameter]="25"></mat-spinner>
  </div>
</div>

<!-- <div class="WelcomeMessage" *ngIf="this.ShowSearchProductsPageMessage == true && this.B2BHomePageMessage?.length > 0;">
  <div class="WelcomeMessageTitle unSelectable">
    <i class="material-icons">info_outline</i>
    {{'Notice' | translate}}
  </div>
  <div class="WelcomeMessageClose" (click)="CloseShowSearchProductsPageMessage();">
    <i class="material-icons">close</i>
  </div>
  <div class="WelcomeMessageBody">
    {{this.B2BHomePageMessage}}
  </div>
</div> -->

<div class="overlay dashOverlay" *ngIf="this.parent.itemOverlay == true;" (click)="this.parent.CloseItemOverlay();"></div>

<!-- <div class="B2BBodyTopSearchContainer">
    <p class="B2BBodyTopSearchContainerTitle">{{'SearchProducts' | translate}}</p>
    <div class="CentralSearchContainer">
      <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
      <input type="text" class="CentralSearch" placeholder="ex: 6GK5005-0BA00-1AB2" (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
      <i class="material-icons" *ngIf="!(this.Filter?.SearchTerm?.length > 0) && !loadingProducts;">search</i>
      <i class="material-icons" style="color:red;" *ngIf="this.Filter?.SearchTerm?.length > 0 && !loadingProducts;" (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>

      <div class="CentralSearchResultsContainer" *ngIf="SearchedProducts?.length > 0;">
        <div *ngFor="let p of this.SearchedProducts;" class="CentralSearchResult" (click)="this.parent.AddNewCartItem(p); this.SearchedProducts = [];">
          {{p.FKBrandName}} {{p.ProductName}}
          <span *ngIf="p.ProductPartNumber?.length > 0 && p.ProductPartNumber != p.Name;">({{p.ProductPartNumber}})</span>
        </div>
      </div>
    </div>
</div> -->

<div class="ColorGuideContainer">

  <!-- <div class="ColorGuideContainerTitle">
    <i class="material-icons">info_outline</i>
    <span>{{'UsageInstructions' | translate}}</span>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #32aa3a;">
    </div>
    <div class="ColorGuideSpan" style="background: #d2fed2;">
      {{'ValidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #aaa;">
    </div>
    <div class="ColorGuideSpan" style="background: #ddd;color: #000;">
      {{'InvalidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #ff8987!important;">
    </div>
    <div class="ColorGuideSpan" style="background: #ff8987!important;color: #000;">
      {{'UnknownProduct' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #f60;">
    </div>
    <div class="ColorGuideSpan" style="background: #ffcaa1;color: #000;">
      {{'AwaitingSelectionRow' | translate}}
    </div>
  </div> -->
</div>

<!-- Brand Exceptions Messages -->
<div class="BrandExceptionsMessagesContainer" *ngIf="this.parent.Cart?.BrandExceptions != null && this.parent.Cart?.BrandExceptions?.length > 0;">
  <div class="BrandExceptionMessage" *ngFor="let e of this.parent.Cart.BrandExceptions">
    <div class="BrandExceptionIcon">
      <i class="material-icons">info</i>
    </div>
    <div class="BrandExceptionContent">
      <div class="BrandExceptionBrand">{{e.BrandName}}</div>
      <div class="BrandExceptionText">{{e.UIMessage}}</div>
    </div>
  </div>
</div>

<!-- Partner Stock Price Notice -->
<div class="BrandExceptionsMessagesContainer" *ngIf="hasPartnerStockItems">
  <div class="BrandExceptionMessage">
    <div class="BrandExceptionIcon">
      <i class="material-icons">info</i>
    </div>
    <div class="BrandExceptionContent">
      <div class="BrandExceptionText">{{'PartnerStockPriceNotice' | translate}}</div>
    </div>
  </div>
</div>

</div><!-- END TAB: Terms & Conditions -->

<!-- ═══════════════════════════════════════════════════════════════════ -->
<!-- TAB: Product-Pricing -->
<!-- ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="activeSearchTab === 'pricing'">

<div class="WelcomeTitle">
  {{'PriceListWelcomeTitle' | translate}}
</div>

<div class="GridTotals" *ngIf="this.parent.Cart?.Currency?.ID > 0;">

   <span class="IntegerSpan" style="margin-right: 10px;" *ngIf="this.loadingProducts != true;">Total:</span>
   <span class="IntegerSpan" *ngIf="this.loadingProducts != true;">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}</span>
   <span class="DecimalSpan" *ngIf="this.loadingProducts != true;">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}}</span>
   <span class="IntegerSpan" *ngIf="this.loadingProducts != true;">{{this.parent.Cart?.Currency?.Symbol}}</span>

   <mat-spinner class="smallSpinner GridTotalsProgressBar" *ngIf="this.loadingProducts == true;" [diameter]="25"></mat-spinner>

   <div class="GridTotalsDisclaimerContainer" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false">
      <div class="HoverContentContainer" *ngIf="isHovering">
        <p *ngFor="let a of this.parent.RelevantAgents">{{a.Email}} ({{a.Department?.Name}}) ({{a.Phone}})</p>
      </div>
    <i class="material-icons">lightbulb</i>
    <i class="material-icons">email</i>
    <span class="GridTotalsDisclaimerContainerInfo">
      {{'ForEmailOrders' | translate}}: orders@foxline.ro
    </span>
   </div>
  </div>

<div class="GridCommandCenter" *ngIf="this.parent.B2BPartner?.FinancialData?.Status?.ID !== -3">
  <!-- Download Excel -->
  <div class="GridCommandButton" (click)="this.ExportB2BGrid();">
    <i class="material-icons">downloading</i>
    <span>{{'DownloadExcel' | translate}}</span>
  </div>

  <!-- Download Official Offer -->
  <div class="GridCommandButton" (click)="this.parent.DownloadOfficialOffer();">
    <i class="material-icons">attach_file</i>
    <span>{{'DownloadOfficialOffer' | translate}}</span>
  </div>

  <!-- SendRFQ (disabled when Status -1 or 1) -->
  <div class="GridCommandButton" *ngIf="this.parent.Cart?.Status?.ID == -1 || this.parent.Cart?.Status?.ID == 1;"
       [class.disabled]="true"
       matTooltip="{{this.parent.Cart?.Status?.Description}}"
       matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </div>

  <!-- SendRFQ (enabled when Status 0) -->
  <div class="GridCommandButton GridCommandButtonOrange"
       *ngIf="this.parent.Cart?.Status?.ID == 0;"
       (click)="this.OpenAskAddNewRFQQuestion();"
       matTooltip="{{this.parent.Cart?.Status?.Description}}"
       matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </div>

  <!-- SendPO (disabled when Status != 1) -->
  <div class="GridCommandButton"
       *ngIf="this.parent.Cart?.Status?.ID != 1;"
       [class.disabled]="true"
       matTooltip="{{this.parent.Cart?.Status?.Description}}"
       matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">arrow_forward</i>
    <span>{{'SendPO' | translate}}</span>
  </div>

  <!-- SendPO (enabled when Status 1) -->
  <div class="GridCommandButton GridCommandButtonGreen"
       *ngIf="this.parent.Cart?.Status?.ID == 1 && this.loadingProducts != true;"
       (click)="this.OpenAskAddNewRFQasPOQuestion();"
       matTooltip="{{this.parent.Cart?.Status?.Description}}"
       matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">arrow_forward</i>
    <span>{{'SendPO' | translate}}</span>
  </div>

  <!-- Clear Grid -->
  <div class="GridCommandButton GridCommandButtonRed" style="float: right;" (click)="this.AskClearGridQuestion();">
    <i class="material-icons">close</i>
    <span>{{'ClearGrid' | translate}}</span>
  </div>
</div>

<div class="OwnAGGridContainer" style="position: relative!important;">
  <!-- Blocked Account Overlay -->
  <div class="BlockedAccountOverlay" *ngIf="this.parent.B2BPartner?.FinancialData?.Status?.ID === -3"></div>
  <ag-grid-angular
  class="ag-theme-alpine"
  style="width: 100%;"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  (cellValueChanged)="onCellValueChanged($event)"
  (gridReady)="onGridReady($event)">
</ag-grid-angular>

<div class="SearchResultsAlternativesContainer animated fadeIn" *ngIf="ShowSearchResultsAlternatives === true" [ngStyle]="SearchResultsPosition">
  <div class="SearchResultsHeader">
    <span>{{'AlternativeResults' | translate}}</span>
    <button class="CloseBtn" (click)="ShowSearchResultsAlternatives = false">×</button>
  </div>
  <div class="SearchResultsList" *ngIf="this.LoadingSideOffers == true;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div class="SearchResultsList" *ngIf="this.LoadingSideOffers != true;">
    <div class="SearchResultItem" *ngFor="let result of SearchResultAlternatives" (click)="SwitchGridResultAlternative(result)" [ngClass]="{ 'SelectedItem': result.IsSelected }">
  <div class="SearchResultTitle">
    {{ result.ProductName }} {{ result.ProductPartNumber }}
    <span *ngIf="result.IsSelected" class="SelectedTag">✓ {{ 'Selected' | translate }}</span>
  </div>

  <div class="SearchResultMeta">
    <span class="SearchResultBrand">{{ result.FKBrandName }}</span>
    <!-- <span class="SearchResultPrice">
      {{ result.Price?.UIUnitPrice }} {{ result.Price?.Currency?.Symbol }}
    </span> -->
  </div>
  </div>
  </div>
</div>

<!-- brand-only popup -->
<div class="BrandCollateralContainer" *ngIf="ShowBrandCollateral == true" [ngStyle]="BrandPopupPosition">
  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
 <!-- render your brands here -->
    <div class="brand-collateral-item" *ngFor="let b of BrandCollateralList" (click)="SwitchGridBrandVersion2(b);">
      <span>{{ b?.Name}}</span>
      <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
    </div>
  </div>
</div>

<!-- brand-only popup -->
<div class="BrandCollateralContainer" *ngIf="ShowBrandCollateralNewProduct == true" [ngStyle]="BrandPopupPosition">
  <div class="BrandCollateralSearchContainer">
    <input placeholder="{{'SearchBrand' | translate}}" name="BrandCollateralSearchInput" type="text" class="BrandCollateralSearchInput" [(ngModel)]="this.BrandFilter.SearchTerm" matInput (ngModelChange)="this.brandSearchTermUpdate.next($event)">
  </div>
  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
 <!-- render your brands here -->
    <div class="brand-collateral-item" *ngFor="let b of NewProductBrandsList" (click)="AttachBrandToNewProduct(b);">
      <span>{{ b?.Name}}</span>
      <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
    </div>
  </div>
</div>

<div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
     *ngIf="ShowFallbackSelection === true"
     [ngStyle]="SearchResultsPosition">

  <div class="SearchResultsHeader" *ngIf="LoadingSideOffers !== true">
    <span>{{ 'PleaseChooseAnItem' | translate }}</span>
    <button class="CloseBtn" (click)="ShowFallbackSelection = false">×</button>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true">
    <div class="OfferRow">
      <div class="GridCell indexx-column" style="font-style: italic;">
        #
      </div>
      <div class="GridCell brand-column" style="font-style: italic;">
        {{'Brand' | translate}}
      </div>

      <div class="GridCell partnumber-column" style="font-style: italic;">
      {{'ProductCode' | translate}}
      </div>

      <div class="GridCell name-column" style="font-style: italic;">
      {{'ProductName' |  translate}}
      </div>

    <div class="GridCell qty-column" style="font-style: italic;">
      min.{{'Quantity' |  translate}}
    </div>

    <div class="GridCell price-column" style="font-style: italic;">
      {{'SellPrice' |  translate}}
    </div>

    <div class="GridCell total-column" style="font-style: italic;">
      {{'Total' |  translate}}
    </div>

    <div class="GridCell eta-column" style="font-style: italic;">
      {{'ETA' |  translate}}
    </div>

    <div class="GridCell hscode-column" style="font-style: italic;">
      {{'HSCode' |  translate}}
    </div>

    <div class="GridCell coo-column" style="font-style: italic;">
      {{'COO' |  translate}}
    </div>

    <div class="GridCell weight-column" style="font-style: italic;">
      {{'Weight' |  translate}}
    </div>
    <div class="GridCell x-column" style="font-style: italic;">

    </div>
</div>
    <div class="OfferRow"
    *ngFor="let result of FallbackOffers; index as i"
    [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }"
    (click)="SwitchGridResultProduct(result)">

    <div class="GridCell indexx-column">
      {{i + 1}}
    </div>
    <div class="GridCell brand-column">
      {{result.Product?.Brand?.Name}}
    </div>

    <div class="GridCell partnumber-column">
      {{result.Product?.PartNumber}}
    </div>

    <div class="GridCell name-column">
    <span>{{result.Product?.Name}}</span>
    <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
    </div>

    <div class="GridCell qty-column">
    {{result.Quantity}}
    </div>

    <div class="GridCell price-column">
    <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
      <span *ngIf="result.Price?.UIUnitPrice > 0;">{{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Symbol}}</span>
      <span *ngIf="!(result.Price?.UIUnitPrice > 0)" class="RequestPriceGridCellButton">{{'RequestPrice' | translate}}</span>
    </span>
    </div>

    <div class="GridCell total-column">
    <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          <span *ngIf="result.Price?.UIQtyPrice > 0;">{{result.Price?.UIQtyPrice}} {{result.Price?.Currency?.Symbol}}</span>
          <span *ngIf="!(result.Price?.UIQtyPrice > 0)">------- {{result.Price?.Currency?.Symbol}}</span>
    </span>
    </div>

    <div class="GridCell eta-column" style="display: flex; align-items: center;">
    <i class="material-icons"
       *ngIf="result.Product?.Stats?.TrustedManufacturerLeadTime === true"
       style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;"
       [matTooltip]="'Manufacturer stock: ' + (result.Product?.Stats?.ManufacturerStock != null ? result.Product?.Stats?.ManufacturerStock : '-') + '\nTrusted information'"
       matTooltipClass="trusted-tooltip">verified</i>
    <span>{{result.SelectedOffer?.LeadTime?.UIOutput}}</span>
    <span *ngIf="result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true;">(Stock)</span>
    </div>

    <div class="GridCell hscode-column">
    {{result.Product?.Stats?.HSCode}}
    </div>

    <div class="GridCell coo-column">
    {{result.Product?.Stats?.COO?.ShortName}}
    </div>

    <div class="GridCell weight-column">
    <span *ngIf="result.Product?.Stats?.Weight > 0;">
    {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
    </span>
    </div>
    <div class="GridCell x-column">

    </div>
    </div>
  </div>
</div>

<div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
     *ngIf="ShowETAAlternatives === true"
     [ngStyle]="SearchResultsPosition">

  <div class="SearchResultsHeader" *ngIf="LoadingSideOffers !== true">
    <span>{{ 'OtherOffers' | translate }}</span>
    <button class="CloseBtn" (click)="ShowETAAlternatives = false">×</button>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true">
    <div class="OfferRow">
      <div class="GridCell indexx-column" style="font-style: italic;">
        #
      </div>
      <div class="GridCell brand-column" style="font-style: italic;">
        {{'Brand' | translate}}
      </div>

      <div class="GridCell partnumber-column" style="font-style: italic;">
      {{'ProductCode' | translate}}
      </div>

      <div class="GridCell name-column" style="font-style: italic;">
      {{'ProductName' |  translate}}
      </div>

    <div class="GridCell qty-column" style="font-style: italic;">
      min.{{'Quantity' |  translate}}
    </div>

    <div class="GridCell price-column" style="font-style: italic;">
      {{'SellPrice' |  translate}}
    </div>

    <div class="GridCell total-column" style="font-style: italic;">
      {{'Total' |  translate}}
    </div>

    <div class="GridCell eta-column" style="font-style: italic;">
      {{'ETA' |  translate}}
    </div>

    <div class="GridCell hscode-column" style="font-style: italic;">
      {{'HSCode' |  translate}}
    </div>

    <div class="GridCell coo-column" style="font-style: italic;">
      {{'COO' |  translate}}
    </div>

    <div class="GridCell weight-column" style="font-style: italic;">
      {{'Weight' |  translate}}
    </div>
    <div class="GridCell x-column" style="font-style: italic;">
    </div>
</div>
    <div class="OfferRow"
         *ngFor="let result of SideOffers; index as i"
         (click)="SwitchGridProductOffer(result)"
         [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">

         <div class="GridCell indexx-column">
          {{i + 1}}
        </div>
        <div class="GridCell brand-column">
          {{result.Product?.Brand?.Name}}
        </div>

        <div class="GridCell partnumber-column">
          {{result.Product?.PartNumber}}
        </div>

        <div class="GridCell name-column">
          <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
          <span>{{result.Product?.Name}}</span>
          <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
        </div>

      <div class="GridCell qty-column">
          {{result.Quantity}}
      </div>

      <div class="GridCell price-column">
        <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          {{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Symbol}}
        </span>
      </div>

      <div class="GridCell total-column">
        <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          {{result.Price?.UIQtyPrice}}  {{result.Price?.Currency?.Symbol}}
        </span>
      </div>

      <div class="GridCell eta-column" style="display: flex; align-items: center;">
        <i class="material-icons"
           *ngIf="result.Product?.Stats?.TrustedManufacturerLeadTime === true"
           style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;"
           [matTooltip]="'Manufacturer stock: ' + (result.Product?.Stats?.ManufacturerStock != null ? result.Product?.Stats?.ManufacturerStock : '-') + '\nTrusted information'"
           matTooltipClass="trusted-tooltip">verified</i>
        <span>{{result.SelectedOffer?.LeadTime?.UIOutput}}</span>
        <span *ngIf="result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true;">(Stock)</span>
      </div>

      <div class="GridCell hscode-column">
        {{result.Product?.Stats?.HSCode}}
      </div>

      <div class="GridCell coo-column">
        {{result.Product?.Stats?.COO?.ShortName}}
      </div>

      <div class="GridCell weight-column">
        <span *ngIf="result.Product?.Stats?.Weight > 0;">
          {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
        </span>
      </div>
      <div class="GridCell x-column">

      </div>
    </div>
  </div>
</div>

<div class="GridCommandCenter" *ngIf="this.parent.B2BPartner?.FinancialData?.Status?.ID !== -3" style="margin-top: 10px;">
  <div class="GridCommandButton GridCommandButtonBlue" (click)="this.addMoreRows();">
    <i class="material-icons">add</i>
    <span>{{'AddRows' | translate}}</span>
  </div>
</div>

<!-- ✅ Stock Readjusted Popup (Apple-style) -->
<div class="stock-readjusted-popup-container" *ngIf="showStockReadjustedPopup">
  <div class="stock-readjusted-popup">
    <div class="stock-readjusted-icon">
      <i class="material-icons">info</i>
    </div>
    <div class="stock-readjusted-message">
      {{ stockReadjustedMessage }}
    </div>
    <div class="stock-readjusted-products" *ngIf="stockReadjustedProducts?.length > 0">
      <div class="stock-readjusted-product" *ngFor="let product of stockReadjustedProducts">
        [{{ product }}]
      </div>
    </div>
    <div class="stock-readjusted-actions">
      <button class="stock-readjusted-ok-btn" (click)="showStockReadjustedPopup = false;">
        OK
      </button>
    </div>
  </div>
</div>

<!-- ✅ Detected Product Popup (ModernPopup style - Minimalist) -->
<div class="ModernPopupOverlay" *ngIf="ShowDetectedProductPopup" (click)="CloseDetectedProductPopup()">
  <div class="ModernPopup small" style="max-width: 420px;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader compact">
      <div class="ModernPopupTitle">
        <i class="material-icons">search</i>
        <span>{{ 'DetectedProduct' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseDetectedProductPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody compact">
      <!-- Loading State -->
      <div class="DetectedProductLoading compact" *ngIf="LoadingDetectedProduct">
        <mat-spinner diameter="28"></mat-spinner>
        <span>{{ 'SearchingProduct' | translate }}...</span>
      </div>

      <!-- Product Found -->
      <div class="DetectedProductContent compact" *ngIf="!LoadingDetectedProduct && DetectedProductData">
        <p class="DetectedProductDescription compact">
          {{ 'DetectedProductDescription' | translate }}
        </p>
        <div class="DetectedProductInfo compact">
          <!-- Product Name - Editable if no valid product -->
          <div class="ModernFormGroup compact" *ngIf="!DetectedProductData?.Product || DetectedProductData?.Product?.ID === 0">
            <label class="ModernFormLabel">{{ 'ProductName' | translate }}</label>
            <input type="text"
                   class="ModernFormInput compact"
                   [class.ModernFormInputHighlight]="!DetectedProductData?.Product?.Name?.trim()"
                   [placeholder]="'EnterProductName' | translate"
                   [(ngModel)]="DetectedProductData.Product.Name">
          </div>
          <!-- Product Name - Read-only if valid product -->
          <div class="DetectedProductReadOnly" *ngIf="DetectedProductData?.Product?.ID > 0 && DetectedProductData?.Product?.Name?.length > 0">
            <span class="DetectedProductReadOnlyLabel">{{ 'ProductName' | translate }}</span>
            <span class="DetectedProductReadOnlyValue">{{ DetectedProductData.Product.Name }}</span>
          </div>

          <!-- Part Number - Editable if no valid product -->
          <div class="ModernFormGroup compact" *ngIf="!DetectedProductData?.Product || DetectedProductData?.Product?.ID === 0">
            <label class="ModernFormLabel">{{ 'PartNumber' | translate }}</label>
            <input type="text"
                   class="ModernFormInput compact"
                   [placeholder]="'EnterPartNumber' | translate"
                   [(ngModel)]="DetectedProductData.Product.PartNumber">
          </div>
          <!-- Part Number - Read-only if valid product -->
          <div class="DetectedProductReadOnly" *ngIf="DetectedProductData?.Product?.ID > 0 && DetectedProductData?.Product?.PartNumber?.length > 0">
            <span class="DetectedProductReadOnlyLabel">{{ 'PartNumber' | translate }}</span>
            <span class="DetectedProductReadOnlyValue">{{ DetectedProductData.Product.PartNumber }}</span>
          </div>
          <!-- Brand Dropdown with Search -->
          <div class="ModernFormGroup compact DetectedProductBrandRow">
            <label class="ModernFormLabel">{{ 'Brand' | translate }}</label>
            <div class="DetectedProductBrandSelect">
              <div class="DetectedProductBrandTrigger compact"
                   [class.ModernFormInputHighlight]="!DetectedProductData?.Product?.Brand?.ID"
                   (click)="OpenDetectedProductBrandDropdown()">
                <span *ngIf="DetectedProductData?.Product?.Brand?.Name">{{ DetectedProductData.Product.Brand.Name }}</span>
                <span *ngIf="!DetectedProductData?.Product?.Brand?.Name" class="DetectedProductBrandPlaceholder">{{ 'SelectBrand' | translate }}</span>
                <i class="material-icons">expand_more</i>
              </div>
              <!-- Dropdown Overlay (closes dropdown when clicking outside) -->
              <div class="DetectedProductBrandOverlay" *ngIf="DetectedProductShowBrandDropdown" (click)="CloseDetectedProductBrandDropdown()"></div>
              <!-- Dropdown -->
              <div class="DetectedProductBrandDropdown" *ngIf="DetectedProductShowBrandDropdown" (click)="$event.stopPropagation()">
                <div class="DetectedProductBrandSearchBox">
                  <i class="material-icons">search</i>
                  <input type="text"
                         [placeholder]="'SearchBrand' | translate"
                         [(ngModel)]="DetectedProductBrandSearchTerm"
                         (ngModelChange)="detectedProductBrandSearchUpdate.next($event)"
                         (focus)="SearchBrandsForDetectedProductPopup(DetectedProductBrandSearchTerm)">
                  <button class="DetectedProductBrandSearchClose" *ngIf="DetectedProductShowBrandDropdown" (click)="CloseDetectedProductBrandDropdown()">
                    <i class="material-icons">close</i>
                  </button>
                </div>
                <div class="DetectedProductBrandList">
                  <div class="DetectedProductBrandLoading" *ngIf="DetectedProductBrandsLoading">
                    <mat-spinner diameter="24"></mat-spinner>
                  </div>
                  <div class="DetectedProductBrandItem"
                       *ngFor="let brand of DetectedProductBrandsList"
                       (click)="SelectDetectedProductBrand(brand)"
                       [class.selected]="DetectedProductData?.Product?.Brand?.ID === brand.ID">
                    <span>{{ brand.Name }}</span>
                    <i class="material-icons" *ngIf="DetectedProductData?.Product?.Brand?.ID === brand.ID">check</i>
                  </div>
                  <div class="DetectedProductBrandEmpty" *ngIf="!DetectedProductBrandsLoading && DetectedProductBrandsList?.length === 0">
                    {{ 'NoBrandsFound' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="DetectedProductRow" *ngIf="DetectedProductData?.Product?.Stats?.HSCode?.length > 0;">
            <span class="DetectedProductLabel">{{ 'HSCode' | translate }}:</span>
            <span class="DetectedProductValue">{{ DetectedProductData.Product?.Stats?.HSCode }}</span>
          </div>
          <div class="DetectedProductRow" *ngIf="DetectedProductData?.Product?.Stats?.COO?.ID > 0;">
            <span class="DetectedProductLabel">{{ 'COO' | translate }}:</span>
            <span class="DetectedProductValue">{{ DetectedProductData.Product.Stats?.COO?.ShortName }}</span>
          </div>
          <div class="DetectedProductRow" *ngIf="DetectedProductData?.Product?.Stats?.Weight > 0">
            <span class="DetectedProductLabel">{{ 'Weight' | translate }}:</span>
            <span class="DetectedProductValue">{{ DetectedProductData.Product.Stats.Weight }} {{ DetectedProductData.Product.Stats.WeightMeasurementType?.Name }}</span>
          </div> -->
        </div>
      </div>

      <!-- No Product Found -->
      <div class="DetectedProductNotFound compact" *ngIf="!LoadingDetectedProduct && !DetectedProductData">
        <i class="material-icons">search_off</i>
        <p>{{ 'NoProductDetected' | translate }}</p>
        <p class="DetectedProductSearchTerm">{{ 'SearchTerm' | translate }}: <strong>{{ DetectedProductSearchTerm }}</strong></p>
      </div>

      <!-- Success State -->
      <div class="DetectedProductSuccess compact" *ngIf="AskPriceDeliverySuccess">
        <i class="material-icons">check_circle</i>
        <p class="DetectedProductSuccessTitle">{{ 'AskPriceDeliverySuccessTitle' | translate }}</p>
        <p class="DetectedProductSuccessDescription">{{ 'AskPriceDeliverySuccessDescription' | translate }}</p>
      </div>

      <!-- Error State -->
      <div class="DetectedProductError compact" *ngIf="AskPriceDeliveryError">
        <i class="material-icons">error</i>
        <p class="DetectedProductErrorMessage">{{ AskPriceDeliveryError }}</p>
      </div>
    </div>
    <div class="ModernPopupFooter compact">
      <button class="ModernButton outline compact" (click)="CloseDetectedProductPopup()">
        {{ 'Close' | translate }}
      </button>
      <button class="ModernButton success compact" (click)="AskPriceAndDelivery()"
              [disabled]="LoadingDetectedProduct || LoadingAskPriceDelivery || AskPriceDeliverySuccess || !DetectedProductData?.Product?.Name?.trim() || !DetectedProductData?.Product?.Brand?.ID"
              *ngIf="!AskPriceDeliverySuccess">
        <mat-spinner diameter="14" *ngIf="LoadingAskPriceDelivery"></mat-spinner>
        <i class="material-icons" *ngIf="!LoadingAskPriceDelivery">send</i>
        <span>{{ 'AskPriceAndDelivery' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Duplicate Order Detected Popup (ModernPopup style) -->
<div class="ModernPopupOverlay" *ngIf="this.parent.ShowDuplicateOrderPopup" (click)="CloseDuplicateOrderPopup()">
  <div class="ModernPopup large" style="max-width: 620px;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #ff9800;">warning</i>
        <span>{{ 'DuplicateOrderDetected' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseDuplicateOrderPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription">
        The order you are trying to add, could be a duplicate order already sent.
      </p>

      <!-- Existing Order Details Table -->
      <div class="DuplicateOrderItemsTable" *ngIf="this.parent.DuplicateOfferRequest">
        <table class="DuplicateOrderTable">
          <thead>
            <tr>
              <th>{{ 'DebatorPO' | translate }}</th>
              <th>{{ 'ReferenceNumber' | translate }}</th>
              <th>{{ 'Total' | translate }}</th>
              <th>Automotive ID</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ this.parent.DuplicateOfferRequest?.DebatorPO || '-' }}</td>
              <td>{{ this.parent.DuplicateOfferRequest?.ReferenceNumber || '-' }}</td>
              <td>{{ this.parent.DuplicateOfferRequest?.Cart?.Total?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ this.parent.DuplicateOfferRequest?.Cart?.Currency?.Name }}</td>
              <td>{{ this.parent.DuplicateOfferRequest?.ID || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="CloseDuplicateOrderPopup()">
        {{ 'Close' | translate }}
      </button>
      <button class="ModernButton" style="background: #f60; color: #fff;" (click)="OpenResendOrderPINPopup()">
        <i class="material-icons">send</i>
        <span>Send Order Anyway</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Resend Order PIN Confirmation Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowResendPINPopup" (click)="CloseResendPINPopup()">
  <div class="ModernPopup" style="max-width: 450px;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f60;">security</i>
        <span>{{ 'ResendOrderConfirmation' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseResendPINPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="margin-bottom: 20px;">
        {{ 'ResendOrderPINMessage' | translate }}
      </p>

      <!-- Generated PIN Display -->
      <div class="PINDisplay">
        <span class="PINLabel">{{ 'YourPIN' | translate }}:</span>
        <div class="PINBoxes">
          <div class="PINBox generated" *ngFor="let digit of GeneratedPIN">{{ digit }}</div>
        </div>
      </div>

      <!-- PIN Input -->
      <div class="PINInputSection">
        <span class="PINLabel">{{ 'EnterPIN' | translate }}:</span>
        <div class="PINBoxes">
          <input type="text" class="PINBox input" maxlength="1"
                 [(ngModel)]="EnteredPIN[0]" (input)="onPINInput($event, 0)"
                 (keydown)="onPINKeydown($event, 0)" #pinInput0>
          <input type="text" class="PINBox input" maxlength="1"
                 [(ngModel)]="EnteredPIN[1]" (input)="onPINInput($event, 1)"
                 (keydown)="onPINKeydown($event, 1)" #pinInput1>
          <input type="text" class="PINBox input" maxlength="1"
                 [(ngModel)]="EnteredPIN[2]" (input)="onPINInput($event, 2)"
                 (keydown)="onPINKeydown($event, 2)" #pinInput2>
          <input type="text" class="PINBox input" maxlength="1"
                 [(ngModel)]="EnteredPIN[3]" (input)="onPINInput($event, 3)"
                 (keydown)="onPINKeydown($event, 3)" #pinInput3>
        </div>
      </div>

      <!-- Error Message -->
      <p class="PINError" *ngIf="PINMismatchError">
        <i class="material-icons">error</i>
        {{ 'PINMismatch' | translate }}
      </p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="CloseResendPINPopup()">
        {{ 'Close' | translate }}
      </button>
      <button class="ModernButton" style="background: #f60; color: #fff;"
              (click)="VerifyPINAndResendOrder()" [disabled]="!isPINComplete()">
        <i class="material-icons">send</i>
        <span>{{ 'Resend' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Mandatory Shipping Address Completion Modal -->
<div class="MandatoryAddressOverlay" *ngIf="showMandatoryAddressModal">
  <div class="MandatoryAddressPopup" (click)="$event.stopPropagation()">
    <div class="MandatoryAddressHeader">
      <div class="MandatoryAddressTitle">
        <i class="material-icons">edit_location</i>
        <span>{{ 'CompleteShippingAddress' | translate }}</span>
      </div>
    </div>
    <div class="MandatoryAddressBody">
      <p class="MandatoryAddressDescription">{{ 'CompleteShippingAddressDescription' | translate }}</p>

      <div class="MandatoryAddressGrid">
        <!-- Left Column: Address Details -->
        <div class="MandatoryAddressColumn">
          <div class="MandatoryAddressSectionTitle">
            <i class="material-icons">place</i>
            {{ 'AddressDetails' | translate }}
          </div>

          <!-- Country Dropdown -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.Country?.ID">{{ 'Country' | translate }} *</label>
            <div class="MandatoryAddressDropdownContainer">
              <div class="MandatoryAddressDropdownOverlay" *ngIf="showMandatoryAddressCountryDropdown" (click)="showMandatoryAddressCountryDropdown = false"></div>
              <div class="MandatoryAddressDropdownBar" [class.open]="showMandatoryAddressCountryDropdown" [class.filled]="mandatoryAddressEdit?.Country?.ID"
                   (click)="getMandatoryAddressCountries(); showMandatoryAddressCountryDropdown = !showMandatoryAddressCountryDropdown">
                <span class="MandatoryAddressDropdownText" [class.placeholder]="!mandatoryAddressEdit?.Country?.ID">
                  {{ mandatoryAddressEdit?.Country?.Name || ('SelectCountry' | translate) }}
                </span>
                <i class="material-icons MandatoryAddressDropdownArrow">expand_more</i>
              </div>
              <div class="MandatoryAddressDropdownResults" *ngIf="showMandatoryAddressCountryDropdown">
                <div class="MandatoryAddressDropdownOption" *ngFor="let c of mandatoryAddressCountries"
                     [class.selected]="mandatoryAddressEdit?.Country?.ID === c.ID"
                     (click)="selectMandatoryAddressCountry(c)">
                  {{ c.Name }}
                  <i class="material-icons check-icon" *ngIf="mandatoryAddressEdit?.Country?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <!-- State/Region -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.State?.trim()">{{ 'StateProvince' | translate }} *</label>
            <input type="text" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.State?.trim()" placeholder="{{ 'StateProvince' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.State">
          </div>

          <!-- City -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.City?.trim()">{{ 'Partners.PartnerWindow.City' | translate }} *</label>
            <input type="text" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.City?.trim()" placeholder="{{ 'Partners.PartnerWindow.City' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.City">
          </div>

          <!-- Address Line -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.AddressLine?.trim()">{{ 'Partners.PartnerWindow.AddressLine' | translate }} *</label>
            <input type="text" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.AddressLine?.trim()" placeholder="{{ 'Partners.PartnerWindow.AddressLine' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.AddressLine">
          </div>

          <!-- Zip Code -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.ZipCode?.trim()">{{ 'ZipCode' | translate }} *</label>
            <input type="text" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.ZipCode?.trim()" placeholder="{{ 'ZipCode' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.ZipCode">
          </div>
        </div>

        <!-- Right Column: Contact Info -->
        <div class="MandatoryAddressColumn">
          <div class="MandatoryAddressSectionTitle">
            <i class="material-icons">person</i>
            {{ 'Partners.PartnerWindow.ContactInfo' | translate }}
          </div>

          <!-- Contact Person -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.ContactPerson?.trim()">{{ 'ContactName' | translate }} *</label>
            <input type="text" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.ContactPerson?.trim()" placeholder="{{ 'ContactName' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.ContactPerson">
          </div>

          <!-- Email -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.Email?.trim()">{{ 'Email' | translate }} *</label>
            <input type="email" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.Email?.trim()" placeholder="{{ 'Email' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.Email">
          </div>

          <!-- Phone -->
          <div class="MandatoryAddressFormGroup">
            <label class="MandatoryAddressLabel" [class.valid]="mandatoryAddressEdit?.Phone?.trim()">{{ 'Login.Phone' | translate }} *</label>
            <input type="tel" class="MandatoryAddressInput" [class.filled]="mandatoryAddressEdit?.Phone?.trim()" placeholder="{{ 'Login.Phone' | translate }}" autocomplete="off" [(ngModel)]="mandatoryAddressEdit.Phone">
          </div>
        </div>
      </div>
    </div>
    <div class="MandatoryAddressFooter">
      <button class="MandatoryAddressSaveButton" [disabled]="!isShippingAddressValid(mandatoryAddressEdit)" (click)="saveMandatoryAddress()">
        <i class="material-icons">check_circle</i>
        <span>{{ 'SaveButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- B2B Agent Phases Popup -->
<div class="B2BAgentPhasesPopupOverlay" *ngIf="showB2BAgentPhasesPopup" (click)="closeB2BAgentPhasesPopup()">
  <div class="B2BAgentPhasesPopupCard animated fadeIn" (click)="$event.stopPropagation()">
    <div class="B2BAgentPhasesPopupHeader">
      <div class="B2BAgentPhasesPopupHeaderLeft">
        <i class="material-icons">tune</i>
        <span>{{ 'SelectNotificationPhases' | translate }} — {{selectedB2BPhaseAgent?.Name || selectedB2BPhaseAgent?.Email}}</span>
      </div>
      <button class="B2BAgentPhasesCloseBtn" (click)="closeB2BAgentPhasesPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="B2BAgentPhasesPopupBody">
      <p class="B2BAgentPhasesExplanation">
        <i class="material-icons">info_outline</i>
        {{ 'NotificationPhasesExplanation' | translate }}
      </p>
      <div class="B2BAgentPhaseItem" *ngFor="let phase of agentOrderPhases"
           [class.selected]="isPhaseSelectedInPopup(phase)"
           (click)="togglePhaseInPopup(phase)">
        <div class="B2BAgentPhaseItemRow">
          <i class="material-icons" [style.color]="isPhaseSelectedInPopup(phase) ? '#007aff' : '#ccc'">
            {{ isPhaseSelectedInPopup(phase) ? 'check_circle' : 'radio_button_unchecked' }}
          </i>
          <span class="B2BAgentPhaseName">{{phase.Name}}</span>
        </div>
        <p class="B2BAgentPhaseDesc">{{phase.Description}}</p>
      </div>
    </div>
    <div class="B2BAgentPhasesPopupFooter">
      <button class="B2BAgentPhasesSaveBtn" (click)="saveB2BAgentPhases()">
        <i class="material-icons">check</i>
        <span>{{ 'Confirm' | translate }}</span>
      </button>
    </div>
  </div>
</div>

</div><!-- END TAB: Product-Pricing -->